@for (project of filteredProjects; track project; let i = $index; let isFirst = $first; let isLast = $last) {
  <li
    class="spot-list--item"
    data-test-selector="op-header-project-select--item"
    [attr.data-list-selector]="projectListItemIdentifier"
    >
    @if (!project.disabled) {
      <a
        tabindex="-1"
        class="spot-list--item-action"
        [ngClass]="{
          'spot-list--item-action_disabled': project.disabled,
          'spot-list--item-action_active': (searchableProjectListService.selectedItemID$ | async) === project.id
        }"
        [href]="extendedUrl(project.identifier)"
        [attr.data-list-selector]="projectListActionIdentifier"
        [attr.data-project-id]="project.id"
        [attr.data-test-selector]="currentProjectService.id === project.id.toString() ? 'op-header-project-select--active-item' : null"
        >
        <span
          class="spot-list--item-title spot-list--item-title_ellipse-text"
          data-test-selector="op-header-project-select--item-title"
          >
          <span
            [opSearchHighlight]="searchText"
          [textContent]="project.name"></span>
          @if (favorited?.includes(project.id.toString())) {
            <svg
              star-fill-icon
              class="op-primer--star-icon"
              size="small"
            ></svg>
          }
        </span>
        @if (currentProjectService.id === project.id.toString()) {
          <a
            [href]="extendedUrl(null)"
            data-test-selector="op-header-project-select--item-remove-icon"
            >
            <svg
              x-circle-icon
              size="small"
            ></svg></a>
          }
        </a>
      }
      @if (project.disabled) {
        <span
          class="spot-list--item-action spot-list--item-action_disabled"
          [ngClass]="{
            'spot-list--item-action_active': (searchableProjectListService.selectedItemID$ | async) === project.id
          }"
          >
          <span
            class="spot-list--item-title spot-list--item-title_ellipse-text"
            data-test-selector="op-header-project-select--item-disabled-title"
          >{{ project.name }}</span>
        </span>
      }
      @if (project.children.length) {
        <ul
          op-header-project-select-list
          [projects]="project.children"
          [displayMode]="displayMode"
          [favorited]="favorited"
          [selected]="selected"
          [searchText]="searchText"
        ></ul>
      }
    </li>
  }
